"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Navigate() {
  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
      level: 2
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      className: _defaultModule["default"]['link'],
      to: process.env['PUBLIC_URL'] + '/operations/invoices',
      "data-locator": "payouts.header.link"
    }, "\u041F\u043B\u0430\u0442\u0435\u0436\u0438"))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
      level: 2,
      "data-locator": "payouts.header"
    }, "\u0412\u044B\u043F\u043B\u0430\u0442\u044B")));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = /*#__PURE__*/_react["default"].memo(Navigate);

exports["default"] = _default;